import { isAxiosError } from "axios";

/** `ValidationPipe` sends one message per failed rule, which would otherwise run together */
export const apiErrorMessage = (error: unknown, fallback: string): string => {
    const message: unknown = isAxiosError(error) ? error.response?.data?.message : undefined;

    if (typeof message === "string" && message.trim() !== "") {
        return message;
    }

    if (Array.isArray(message) && message.length > 0) {
        // class-validator's own messages carry no full stop, the API's custom ones do
        return message.map((line) => (/[.!?]$/.test(String(line)) ? line : `${line}.`)).join(" ");
    }

    return fallback;
};

/** For analytics: the status alone, as a refusal's message can name the person it's about */
export const apiErrorStatus = (error: unknown): number | "network" | "unknown" =>
    isAxiosError(error) ? (error.response?.status ?? "network") : "unknown";
